import { render, staticRenderFns } from "./practice-overview.vue?vue&type=template&id=73f65a8e"
import script from "./practice-overview.vue?vue&type=script&lang=js"
export * from "./practice-overview.vue?vue&type=script&lang=js"
import style0 from "./practice-overview.vue?vue&type=style&index=0&id=73f65a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports